import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import SearchField from 'react-search-field';
import ContentSelector from '../../ContentSelector'

const AccessModel = ({language, access}) => {
        const [contentTypesList, setContentTypesList] = useState()
        const [list, setList] = useState()
        const [accessCreate, setAccessCreate] = useState()
        const [accessDraft, setAccessDraft] = useState()
        const [accessPublish, setAccessPublish] = useState()
        const [accessDelete, setAccessDelete] = useState()
        const [showAddContentType, setShowAddContentType] = useState(false)
    
    
        useEffect(() => {
            const getAccessModelData = async () => {
                setContentTypesList(access.contentTypes)
                setList(access.contentTypes)
                setAccessCreate(access.accessCreate)
                setAccessDraft(access.accessDraft)
                setAccessPublish(access.accessPublish)
                setAccessDelete(access.accessDelete)
            }
            getAccessModelData()
    
        },[access])

        const handleAddArticleShow = e => {
            setShowAddContentType(showAddContentType ? false : true)
        }

        const handleAddArticle = (contentTypes) => {
            contentTypes.forEach(async item => {
                const data = await postAccessContentType(item)
                setContentTypesList([...contentTypesList, data.postAccessContentType])
                setList([...contentTypesList, data.postAccessContentType])
            });
        }
    
        const postAccessContentType = async (contentType) => {
            var graphql = JSON.stringify({
                query: `mutation ($profileId: Long, $accessId: Long, $contentTypeId: Guid){
                            postAccessContentType(profileId:$profileId, accessId: $accessId, contentTypeId: $contentTypeId) {
                                id
                                contentTypeName
                            }
                        }`,
                variables: {
                    "profileId" : access.profileId
                    , "accessId" : access.id
                    , "contentTypeId" : contentType.id
                }
              })
            const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
                method:'POST',
                headers:{
                    'Authorization':'Basic ' + global.config.Editor.authToken
                    ,'Content-Type': 'application/json'
                },
                body: graphql
            })
            .then(response => response.text())
            .then(result => {return JSON.parse(result).data})
            .catch(error => console.log('error', error))
            const data = await res
            return data
        }
        
        
        const searchContentTypes = (keyword) => {
            setList(
                contentTypesList.filter((contentType) => contentType.contentTypeName.toLowerCase().includes(keyword.toLowerCase()))
            )
        }

        let contentTypesHtml, accessModelHtml

        if(access){
            accessModelHtml = (
                <div>
                    <h3>{language.value === "DA" ? "Adgangs profil for" : "Access profile for"}</h3>
                    <h4>{access.contentModel.modelName}</h4>
                    <label className="input_label checkbox">
                        <input type="checkbox" name="accessCreate" checked={accessCreate} onChange={ e => setAccessCreate(accessCreate ? false : true) } />
                        <span>{language.value === 'DA' ? 'Opret' : 'Create'}</span>
                    </label>
                    <label className="input_label checkbox">
                        <input type="checkbox" name="accessDraft" checked={accessDraft} onChange={ e => setAccessDraft(accessDraft ? false : true) } />
                        <span>{language.value === 'DA' ? 'Rediger' : 'Edit'}</span>
                    </label>
                    <label className="input_label checkbox">
                        <input type="checkbox" name="accessPublish" checked={accessPublish} onChange={ e => setAccessPublish(accessPublish ? false : true) } />
                        <span>{language.value === 'DA' ? 'Publiser' : 'Publish'}</span>
                    </label>
                    <label className="input_label checkbox">
                        <input type="checkbox" name="accessDelete" checked={accessDelete} onChange={ e => setAccessDelete(accessDelete ? false : true) } />
                        <span>{language.value === 'DA' ? 'Slet' : 'Delete'}</span>
                    </label>
                </div>
            )
        }
    
        if(list){
            contentTypesHtml = (
                <div>
                    <h3>{language.value === "DA" ? "Adgang til artikler" : "Access to articles"}</h3>
                    <button onClick={handleAddArticleShow} className="cc-btn blue-gradient">{language.value === 'DA' ? 'Tilføj artikel' : 'Add article'}</button>
                    <SearchField key="searchInput" classNames="searchInput" name="searchInput" onChange={searchContentTypes} placeholder={language.value === 'DA' ? 'Søger i artikelnavn' : 'Search in article name'}  autoComplete="off"/>
                    <div id="cc_relation_list">
                    {
                        list.map((contentType) => (
                            <div key={contentType.id} className="cc_relation_list_item"> 
                                <div>
                                    <Link to={`/content/${contentType.id}`}>{contentType.contentTypeName}</Link>
                                </div>
                                <div className="cc_relation_list_item_remove">
                                    <span>{language.value === 'DA' ? 'Fjern' : 'Remove'}</span>
                                    <i className="sprite-icon icon-bin"></i>
                                </div>
                            </div>
                        ))
                    }
                    </div>
                </div>
            )
        }
    
        return (
            <>
                {accessModelHtml}
                {contentTypesHtml}
                {(access) &&
                <ContentSelector language={language}
                                type={'contentTypes'}
                                isVisible={showAddContentType}
                                setIsVisible={setShowAddContentType}
                                callback={handleAddArticle}
                                filter={[access.contentModel.id]}/>
                }
            </>
        )
}

export default AccessModel
